import GOSubmitDataKU from './GOSubmitDataKU'

export default GOSubmitDataKU
